export default __webpack_public_path__ + "alberta-fax.0c485e59c34c2b9f2715.svg";